/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ViennaAddressSearchResult
 */
export interface ViennaAddressSearchResult {
    /**
     * 
     * @type {string}
     * @memberof ViennaAddressSearchResult
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof ViennaAddressSearchResult
     */
    houseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ViennaAddressSearchResult
     */
    zipCode: string;
}

/**
 * Check if a given object implements the ViennaAddressSearchResult interface.
 */
export function instanceOfViennaAddressSearchResult(value: object): value is ViennaAddressSearchResult {
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    return true;
}

export function ViennaAddressSearchResultFromJSON(json: any): ViennaAddressSearchResult {
    return ViennaAddressSearchResultFromJSONTyped(json, false);
}

export function ViennaAddressSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViennaAddressSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
    };
}

export function ViennaAddressSearchResultToJSON(json: any): ViennaAddressSearchResult {
    return ViennaAddressSearchResultToJSONTyped(json, false);
}

export function ViennaAddressSearchResultToJSONTyped(value?: ViennaAddressSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'zipCode': value['zipCode'],
    };
}

